"use client"

import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { motion } from "motion/react"

const sectionTitleVariants = cva(
  "flex items-center w-fit font-light mb-2",
  {
    variants: {
      variant: {
        section: "border rounded-4xl px-4 h-8 text-small",
        step: "text-xs px-3 py-1 rounded-full"
      },
      theme: {
        light: "",
        dark: ""
      }
    },
    compoundVariants: [
      {
        variant: "section",
        theme: "light",
        class: "border-background/20 bg-background/10 text-white"
      },
      {
        variant: "section",
        theme: "dark",
        class: "border-cta/40 bg-cta/20 text-cta"
      },
      {
        variant: "step",
        theme: "light",
        class: "font-semibold"
      },
      {
        variant: "step",
        theme: "dark",
        class: "bg-cta/20"
      }
    ],
    defaultVariants: {
      variant: "section",
      theme: "light"
    }
  }
)

interface SectionTitleProps extends VariantProps<typeof sectionTitleVariants> {
  children: React.ReactNode
  className?: string
}

export function SectionTitle({ 
  children, 
  className,
  variant,
  theme
}: SectionTitleProps) {
  return (
    <motion.span 
      className={cn(sectionTitleVariants({ variant, theme }), className)}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ 
        opacity: 1, 
        y: 0,
        transition: { duration: 0.3 } 
      }}
      viewport={{ once: true, margin: "-10px" }}
    >
      {children}
    </motion.span>
  )
}